import * as React from 'react'
import Helmet from 'react-helmet'
import Gallery from "./../components/gallery"

import './gallery-la.css'

function importAll(r : any) {
  return r.keys().map(r);
}
const images = importAll(require.context('./../assets/gallery-la', false, /\.(png|jpg|svg)$/));

// Please note that you can use https://github.com/dotansimha/graphql-code-generator
// to generate all types from graphQL schema
interface IndexPageProps {
  data: {
    site: {
      siteMetadata: {
        title: string
      }
    }
  }
}

export default class extends React.Component<IndexPageProps, {}> {
  constructor(props: IndexPageProps, context: any) {
    super(props, context)
  }
  public render() {
    return (
      <div>
        <Helmet
            bodyAttributes={{
                class: 'gallery-body'
            }}
        />
        <div style={{
            height: "auto",
            backgroundColor: "rgba(255, 255, 255, 0.75)",
            padding: "1px 25px 15px",
          }}>
          <hr style={{margin: 0, marginTop: '10px', borderColor: 'rgb(150, 150, 150)'}}/>
          <hr style={{margin: 0, marginTop: '2px', borderColor: 'rgb(150, 150, 150)'}}/>
          <h1 className="gal-header">
            LANDSCAPE
          </h1>
          <p className="gal-para">
            Under Juniper, Inc. is a premier landscape service company providing design-oriented total landscape systems. Every project we propose to you starts with free artistic sketches created by our principal consultant...
          </p>
          <hr style={{margin: 0, marginBottom: '2px', borderColor: 'rgb(150, 150, 150)'}}/>
          <hr style={{margin: 0, marginBottom: '10px', borderColor: 'rgb(150, 150, 150)'}}/>

          <Gallery images={images}/>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/gallery-la.tsx